import React from "react";
import { useLocation } from "react-router-dom";
import fase2Ct4Jpg from "../../assets/videos/fase2-ct4.jpg";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import "../StartGame.css";
import Scenario2NextCta from "../Scenario2/Scenario2NextCta";
import "./Scenario3.css";

const CAPTION =
	"Durante la intervención, un agente observa un objeto bajo un banco situado a varios metros de los implicados.";

export default function Scenario3Context4() {
	const location = useLocation();
	const activeScenario = getScenarioNumByPath(location.pathname);

	return (
		<div className="start-game-page start-game-page--welcome sc3-context1-dialogue-page sc3-context4-image-page">
			<div className="start-game-inner">
				<div className="start-game-grid sc3-context4-grid">
					<div className="start-game-panel sc3-context1-dialogue-panel sc3-context4-panel">
						<div className="sc3-context4-visual">
							<img
								src={fase2Ct4Jpg}
								alt="Escena en la plaza: objeto bajo un banco"
								className="sc3-context4-image"
								loading="eager"
								decoding="async"
							/>
						</div>

						<p className="start-game-lead sc3-context4-caption" role="doc-subtitle">
							{CAPTION}
						</p>

						<div className="start-game-footer sc3-context1-footer sc3-context4-footer">
							<Scenario2NextCta
								navigateTo={ROUTES.SCENARIO3_FIN}
								activeScenario={activeScenario}
								label="Continuar"
							/>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}
